import type { DocumentNode } from 'graphql';

import { HOLDEM_REGULAR_GAMES_RESPONSE } from '../mocks/gamesData';
import { HOLDEM_REGULAR_QUERY_VARS } from '../mocks/variables';
import {
  type AdditionalParam,
  type FilteredConfig,
  type Integer64,
  type ModularBlock,
  type Platform,
  TableType
} from '../types';

export const getGamesMock = (query: DocumentNode, delay = false, empty = false) => ({
  ...(delay && { delay: Infinity }),
  request: { query, variables: HOLDEM_REGULAR_QUERY_VARS, operationName: 'cashGamesGrouped' },
  result: { data: { cashGamesGrouped: empty ? [] : HOLDEM_REGULAR_GAMES_RESPONSE } }
});

/* eslint-disable no-bitwise */
export const toInteger64 = (value: number | bigint): Integer64 => {
  const intValue = typeof value === 'number' ? Math.floor(value) : value;
  const bigIntValue = BigInt(intValue);
  const lo = Number(bigIntValue & BigInt(0xffffffff));
  const hi = Number((bigIntValue >> BigInt(32)) & BigInt(0xffffffff));

  return {
    lo,
    hi: hi || 0
  };
};

export const extractPlatformConfig = (
  modularBlocks: ModularBlock[] = [],
  platform: Platform
): AdditionalParam[] | null => {
  const relevantBlock = modularBlocks.find(
    (block) => block.additional_config?.select_platform === platform
  );
  return relevantBlock?.additional_config?.additional_params || null;
};

export const filterConfigByPlayMoney = (
  params: AdditionalParam[] | null,
  isPlayMoney: boolean
): FilteredConfig => {
  if (!params) return {};

  return params.reduce((acc: FilteredConfig, param) => {
    if ('stake' in param && param.stake.play_money === isPlayMoney) {
      acc.stakes = [param.stake.stakes];
    }

    if ('multiplier' in param && param.multiplier.play_money === isPlayMoney) {
      const isZoomTable = param.multiplier.table_type === TableType.ZOOM;
      if (isZoomTable) {
        acc.bbMultiplierZoom = param.multiplier.multiplier;
      } else {
        acc.bbMultiplierRegular = param.multiplier.multiplier;
      }
    }

    return acc;
  }, {});
};
